import { AvField, AvForm } from 'availity-reactstrap-validation';
import React, { Component, Fragment } from 'react';
import {
  Button,
  Card,
  CardBody,
  Col,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  UncontrolledAlert,
  UncontrolledTooltip,
} from 'reactstrap';
import swal from 'sweetalert';
import { getLoggedInUser } from '../../../helpers/authUtils';
import { CrudOperations } from '../../../services/CRUDoperations.service';
import { UserAPI } from '../../../services/users.services';
import DepartmentMembers from '../../../utils/DepartmentMembers/DepartmentMembers';
import FileUploader from '../../FileUploader';
import PageTitle from '../../PageTitle';
import Spinner from '../../Spinner';

const Entity = 'Departments';

const _default_thumbnail =
  'data:image/jpeg;base64,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';

class DepartmentManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      GISAssets: [],
      GISUsers: [],
      departments: [],
      isLoading: true,
      newDepartmentModal: false,
      inviteModal: false,
      existingDepartmentModal: false,
      departmentThumbnail: [],
      name: '',
      description: '',
      manager: '',
      thumbnail: _default_thumbnail,
      departmentID: 0,
      departmentObj: null,
      assetsOptions: [],
      selectedAssets: [],
      selectedDepartment: null,
      selectedDepartmentMembers: [],
      loggedInUser: null,
      isInvitingMember: false,
    };
    this.toggleNewDepartmentModal = this.toggleNewDepartmentModal.bind(this);
    this.toggleInviteMembersModal = this.toggleInviteMembersModal.bind(this);
    this.toggleExistingDepartmentModal =
      this.toggleExistingDepartmentModal.bind(this);
  }

  /**
   * Toggles the new department modal
   */
  toggleNewDepartmentModal = () => {
    this.setState((prevState) => ({
      newDepartmentModal: !prevState.newDepartmentModal,
    }));
  };
  toggleInviteMembersModal = () => {
    this.setState((prevState) => ({
      inviteModal: !prevState.inviteModal,
    }));
  };
  toggleExistingDepartmentModal = () => {
    this.setState((prevState) => ({
      existingDepartmentModal: !prevState.existingDepartmentModal,
    }));
  };

  SetSelectedDepartmentMembers = async (department) => {
    const { data } = await UserAPI.GetUsersByDepartment(department);
    this.setState({ selectedDepartmentMembers: data });
  };

  fetchGIS_Services = async (loggedUser) => {
    const __gisServices = await CrudOperations.Get('GisConfiguration');
    this.setState({
      GISAssets: __gisServices.data,
      assetsOptions: [],
      loggedInUser: loggedUser,
    });
    this.__setAssetsOptions();
  };

  __setAssetsOptions = () => {
    const { assetsOptions } = this.state;
    if (this.state.GISAssets.length > 0) {
      this.state.GISAssets.map((s) => {
        assetsOptions.push({
          value: s.gisServicesConfigurationID,
          label: s.name,
        });
      });
    }

    setTimeout(() => {
      this.setState({ assetsOptions });
    }, 20);
  };

  __handleAssetSelectionChange = (evt) => {
    setTimeout(() => {
      this.setState({ selectedAssets: evt });
    }, 20);
  };

  componentDidMount() {
    const loggedUser = getLoggedInUser();
    this.fetchGIS_Services(loggedUser);
    this.__getDepartmentUsers(loggedUser.department);
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  __getDepartmentUsers = (department) => {
    UserAPI.GetUsersByDepartment(department).then((users) => {
      this.setState({ GISUsers: users.data });
      this.__getDepartments();
    });
  };

  __getDepartments = () => {
    CrudOperations.Get(Entity)
      .then((res) => {
        this.setState({ departments: res.data, isLoading: false });
      })
      .catch((err) => {
        console.log('Error fetching departments :: ', err);
      });
  };

  newDepartmentModel = () => {
    // load all users for manager selection
    UserAPI.GetUsers().then((users) => {
      this.setState({
        selectedAssets: [],
        GISUsers: users.data,
        newDepartmentModal: true,
      });
    });
  };

  EditDepartment = (deptObj) => {
    //console.log(deptObj);
    let selectedAssets = [];
    if (deptObj.getDepartmentGISAssets.length > 0) {
      deptObj.getDepartmentGISAssets.map((a) => {
        selectedAssets.push({
          value: a.gisService.gisServicesConfigurationID,
          label: a.gisService.name,
        });
      });
    }

    const { departmentID, name, description, manager, thumbnail } = deptObj;
    UserAPI.GetUsersByDepartment(name).then((users) => {
      this.setState({
        departmentID,
        name,
        description,
        manager,
        thumbnail,
        GISUsers: users.data,
        existingDepartmentModal: true,
        selectedAssets,
        selectedDepartment: deptObj,
        selectedDepartmentMembers: users.data,
      });
    });
  };
  ShowInviteMembersModel = (department) => {
    this.setState({ selectedDepartment: department, inviteModal: true });
  };
  DeleteDepartment = (deptObj) => {
    swal({
      text: `You are about to delete department ${deptObj.name}. Please note if this Department has been linked to a service, it will not be deleted. Are you sure to delete? `,
      closeOnClickOutside: false,
      buttons: { cancel: 'NO', confirm: 'YES' },
      dangerMode: true,
    }).then((action) => {
      if (action) {
        // check if department in use
        CrudOperations.VerifyItemUsedForDeletion(
          deptObj.departmentID,
          'departments'
        ).then((result) => {
          if (result.data) {
            swal(
              `Department ${deptObj.name} has been assigned to work order and cannot be deleted.`
            );
          } else {
            // delete
            CrudOperations.Delete(Entity, deptObj.departmentID)
              .then((res) => {
                this.__getDepartments();
                swal(`Department ${deptObj.name} deleted successfully.`);
              })
              .catch((err) => {
                swal(
                  `Unable to delete department ${deptObj.name}. Please try again later`
                );
                console.log('Error :: ', err);
              });
          }
        });
      }
    });
  };

  __GetThumbnailImageAs64Bit = () => {
    const _promise = new Promise((resolve, reject) => {
      if (this.state.departmentThumbnail.length > 0) {
        const FR = new FileReader();
        FR.onload = (e) => {
          resolve(e.target.result);
        };
        FR.readAsDataURL(this.state.departmentThumbnail[0]);
      } else {
        resolve(_default_thumbnail);
      }
    });
    return _promise;
  };

  __get__department__assets = () => {
    const getDepartmentGISAssets = [];
    if (this.state.selectedAssets && this.state.selectedAssets.length) {
      for (let index = 0; index < this.state.selectedAssets.length; index++) {
        const _DepartmentGISAssets =
          this.state.selectedDepartment.getDepartmentGISAssets[index];
        const __asset = this.state.selectedAssets[index];
        getDepartmentGISAssets.push({
          departmentGISAssetID: _DepartmentGISAssets
            ? _DepartmentGISAssets.departmentGISAssetID
            : 0,
          departmentID: this.state.departmentID,
          gisServicesConfigurationID: __asset.value,
        });
      }
    }

    return getDepartmentGISAssets;
  };
  __get__new__department__assets = () => {
    const getDepartmentGISAssets = [];
    if (this.state.selectedAssets && this.state.selectedAssets.length) {
      for (let index = 0; index < this.state.selectedAssets.length; index++) {
        const __asset = this.state.selectedAssets[index];
        getDepartmentGISAssets.push({
          //departmentGISAssetID: 0,
          //departmentID: this.state.departmentID,
          gisServicesConfigurationID: __asset.value,
        });
      }
    }
    return getDepartmentGISAssets;
  };

  SetUserAndAssets = (userID) => {
    const __assets = [];
    this.state.GISAssets.map((a) => {
      //const asset =
    });
  };

  handleEditDepartment = async (event, values) => {
    /* var _thumbnail = await this.__GetThumbnailImageAs64Bit().then((thumb) => {
      return thumb;
    }); */
    const { department, description, manager } = values;
    let _DepartmentObj = {
      departmentID: this.state.departmentID,
      name: department,
      description: description,
      thumbnail: this.state.thumbnail,
      manager: 'None',
      //getDepartmentGISAssets: this.__get__department__assets(),
    };
    //console.log(_DepartmentObj);
    CrudOperations.Update(Entity, _DepartmentObj)
      .then((res) => {
        this.__getDepartments();
        this.toggleExistingDepartmentModal();
        this.setState({ selectedAssets: [] });
        swal(`Department ${_DepartmentObj.name} updated successfully.`);
      })
      .catch((err) => {
        swal('Unable to update department at this time');
        console.log('Error updating department :: ', err);
      });
  };

  handleNewDepartment = async (event, values) => {
    /* var _thumbnail = await this.__GetThumbnailImageAs64Bit().then((thumb) => {
      return thumb;
    }); */
    const { department, description, manager } = values;
    let NewDepartmentObj = {
      name: department,
      description: description,
      thumbnail: this.state.thumbnail,
      //"totalMembers": 0,
      manager: 'None',
      //getDepartmentGISAssets: this.__get__new__department__assets(),
    };

    CrudOperations.Create(Entity, NewDepartmentObj)
      .then((res) => {
        this.__getDepartments();
        this.toggleNewDepartmentModal();
        this.setState({ selectedAssets: [] });
        swal('Department created successfully!');
      })
      .catch((err) => {
        swal('Something went wrong!');
        console.log('Error :: ', err);
      });
  };

  // validate emails
  /**
   *
   * @param {*} emails // string of emails comma separated
   */
  __validateEmails = (emails) => {
    const errors = [];
    const emailsArray = emails.split(',');
    if (emailsArray.length > 0) {
      emailsArray.map((email, idx) => {
        if (this.validateEmail(email.trim())) {
        } else {
          errors.push(email.trim());
        }
      });
    } else {
      if (this.validateEmail(emails.trim())) {
      } else {
        errors.push(emails);
      }
    }

    return errors;
  };

  validateEmail(email) {
    var re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const isValid = re.test(String(email).toLowerCase());
    //console.log(isValid);
    return isValid;
  }

  __getEmailNotificationReceivers = (emails) => {
    const emailsObj = [];
    const emailArray = emails.split(',');
    if (emailArray.length > 0) {
      emailArray.map((email, idx) => {
        emailsObj.push({ email: email.trim() });
      });
    } else {
      emailsObj.push({ email: emails.trim() });
    }
    return emailsObj;
  };

  handleInviteMembers = async (evt, values) => {
    const { emails } = values;
    // check emails validation
    const emailErrors = this.__validateEmails(emails);
    if (emailErrors.length > 0) {
      let message = `Please provide valid email address for: \n`;
      emailErrors.map((email, idx) => {
        message = message + `${idx + 1}. ${email} \n`;
      });
      swal(message);
      return;
    }

    this.setState({ isInvitingMember: true });

    const _manager = this.state.GISUsers.find(
      (u) => u.id === this.state.loggedInUser.id
    );

    const inviteMembersObj = {
      invitationSenderFullName: `${_manager.firstName} ${_manager.lastName}`,
      invitationSenderEmail: _manager.email,
      appBaseUrl: window.location.origin,
      emailReceivers: this.__getEmailNotificationReceivers(emails),
      departmentName: this.state.selectedDepartment.name,
    };
    const { data } = await CrudOperations.Post(
      'Notifications/InviteMember',
      inviteMembersObj
    );
    //console.log(data);
    this.setState({ isInvitingMember: false });
    if (data.isNotificationSent) {
      swal(data.message);
      this.toggleInviteMembersModal();
    } else {
      swal(
        'There was an error sending the notification. Please try again later'
      );
      console.log('Error inviting members :: ', data.message);
    }
  };

  updateThumbnail = (field, files) => {
    const selectedThumbnail = files[0];

    const FR = new FileReader();
    FR.onload = (e) => {
      this.setState({ thumbnail: e.target.result });
    };
    FR.readAsDataURL(selectedThumbnail);
    /* const state = { ...this.state.state };
    state[field] = fieldValue;
    this.setState(state); */
  };

  _renderUsersOptions = () => {
    return (
      <Fragment>
        {this.state.GISUsers.map((u, index) => {
          return (
            <option key={index} value={`${u.firstName} ${u.lastName}`}>
              {`${u.firstName} ${u.lastName}`}
            </option>
          );
        })}
      </Fragment>
    );
  };

  __renderDepartmentMembers() {
    if (this.state.selectedDepartmentMembers.length > 0) {
      return (
        <>
          <DepartmentMembers
            members={this.state.selectedDepartmentMembers}
            GISAssets={this.state.GISAssets}
          />
        </>
      );
    } else {
      return (
        <UncontrolledAlert color="danger">
          <i className="dripicons-user-group mr-2"></i>{' '}
          <strong>No Members: </strong>
          This department has no members at this time
        </UncontrolledAlert>
      );
    }
  }

  __renderDepartmentAssets(department) {
    const __departmentServices = department.getDepartmentGISAssets;
    if (__departmentServices.length > 0) {
      return (
        <>
          {__departmentServices.map((ds, idx) => (
            <li key={idx} className="list-inline-item ml-1 mb-1">
              <span className="badge badge-success-lighten p-1">
                {ds.gisService.name}
              </span>
            </li>
          ))}
        </>
      );
    } else {
      return (
        <li className="list-inline-item ml-1 mb-1">
          <span className="badge badge-danger-lighten p-1">
            No Assets assigned
          </span>
        </li>
      );
    }
  }

  __renderDepartments() {
    if (this.state.isLoading) {
      return (
        <div style={{ textAlign: 'center', marginTop: '45px' }}>
          <Spinner className="m-2" color={'info'} size={'sm'} />
        </div>
      );
    } else {
      return (
        <Row className="mb-2">
          {this.state.departments.map((dept, i) => {
            return (
              <Col md={6} xl={3} key={'dept-' + dept.departmentID}>
                <Card className="d-block">
                  <React.Fragment>
                    <img
                      className="card-img-top"
                      src={dept.thumbnail}
                      alt="thumbnail"
                    />
                    <div className="card-img-overlay">
                      <div
                        id="btn-div-edit"
                        className="btn-div-edit-department"
                        onClick={() => this.EditDepartment(dept)}
                      >
                        <i className="dripicons-pencil"></i>
                      </div>
                      <UncontrolledTooltip
                        placement="top"
                        target="btn-div-edit"
                      >
                        Edit
                      </UncontrolledTooltip>

                      {/* <UncontrolledDropdown className="card-widgets">
                        <DropdownToggle
                          tag="a"
                          className="arrow-none cursor-pointer"
                        >
                          <i
                            className="dripicons-dots-3"
                            style={{ backgroundColor: '#fff' }}
                          ></i>
                        </DropdownToggle>

                        <DropdownMenu right>
                          <DropdownItem
                            onClick={() => this.EditDepartment(dept)}
                          >
                            <i className="mdi mdi-pencil mr-1"></i>Edit
                          </DropdownItem>
                          <DropdownItem
                            onClick={() => this.DeleteDepartment(dept)}
                          >
                            <i className="mdi mdi-delete mr-1"></i>Delete
                          </DropdownItem>
                        </DropdownMenu>
                      </UncontrolledDropdown> */}
                    </div>
                  </React.Fragment>

                  <CardBody
                    style={{ paddingBottom: '0' }}
                    className={dept.thumbnail ? 'position-relative' : ''}
                  >
                    <h4 className="mt-0">
                      <a href="/" className="text-title">
                        {dept.name}
                      </a>
                    </h4>
                    <p className="text-muted font-13 mb-1">
                      {dept.description}
                      {/* <a href="/" className="font-weight-bold text-muted">
                        view more
                      </a> */}
                    </p>
                    <button
                      className="btn btn-primary btn-sm mb-3 mt-2"
                      onClick={() => this.ShowInviteMembersModel(dept)}
                    >
                      <i className="uil uil-user-plus"></i> Invite Members
                    </button>

                    <p className="mb-1">
                      <span className="pr-2 text-nowrap mb-2 d-inline-block">
                        <i className="mdi mdi-format-list-bulleted-type text-muted mr-1"></i>
                        <b>{dept.openTasks}</b> Task
                        {dept.openTasks > 1 ? 's' : ''}
                      </span>
                      <span className="text-nowrap mb-2 d-inline-block">
                        <i className="mdi mdi-comment-multiple-outline text-muted mr-1"></i>
                        <b>{dept.totalMembers}</b> Member
                        {dept.totalMembers > 1 ? 's' : ''}
                      </span>
                    </p>
                  </CardBody>
                  <div className="text-wrap">
                    <ul className="list-inline font-13 mb-3">
                      {this.__renderDepartmentAssets(dept)}
                    </ul>
                  </div>
                </Card>
              </Col>
            );
          })}
        </Row>
      );
    }
  }

  render() {
    return (
      <Fragment>
        <div>
          <div className="main-content-wrapper-scrollable">
            <div style={{ clear: 'both' }}></div>
            <div>
              <PageTitle
                breadCrumbItems={[
                  { label: 'Map', path: '/apps/workorders' },
                  { label: 'Departments', active: true },
                ]}
                title={'Department Management'}
              />
              <Button
                color="danger"
                className="btn-rounded mb-3"
                onClick={this.newDepartmentModel}
              >
                <i className="mdi mdi-plus"></i> Create Department
              </Button>
              <div>{this.__renderDepartments()}</div>
            </div>
          </div>
        </div>
        <Modal
          isOpen={this.state.newDepartmentModal}
          toggle={this.toggleNewDepartmentModal}
          /* size="lg" */
        >
          <ModalHeader toggle={this.toggleNewDepartmentModal}>
            Create New Department
          </ModalHeader>
          <ModalBody>
            <AvForm className="p-2" onValidSubmit={this.handleNewDepartment}>
              <Row>
                <Col md={12}>
                  <AvField
                    name="department"
                    label="Department name"
                    type="text"
                    required
                  />
                </Col>
                {/* <Col md={4}>
                  <AvField
                    name="manager"
                    label="Supervisor"
                    type="select"
                    className="custom-select"
                  >
                    <option value="Select">Select</option>
                    {this._renderUsersOptions()}
                  </AvField>
                </Col> */}
              </Row>
              {/* <Row className="mb-2">
                <Col md={12}>
                  <Label>Select assets</Label>
                  <Select
                    isMulti={true}
                    options={this.state.assetsOptions}
                    value={this.state.selectedAssets}
                    className="react-select"
                    classNamePrefix="react-select"
                    onChange={(evt) => this.__handleAssetSelectionChange(evt)}
                  ></Select>
                </Col>
              </Row> */}

              <AvField
                name="description"
                label="Description"
                type="textarea"
                required
              />

              <FormGroup>
                <Label>Thumbnail</Label>
                <p className="text-muted font-14">
                  Recommended thumbnail size 800x400 (px).
                </p>
                <FileUploader
                  onFileUpload={(files) => {
                    this.updateThumbnail('departmentThumbnail', files);
                  }}
                />
              </FormGroup>

              <div className="text-right">
                <Button
                  color="light"
                  type="button"
                  className="mr-1"
                  onClick={this.toggleNewDepartmentModal}
                >
                  Cancel
                </Button>
                <Button color="primary" type="submit">
                  Create
                </Button>
              </div>
            </AvForm>
          </ModalBody>
        </Modal>

        {/* Modal Edit */}
        <Modal
          isOpen={this.state.existingDepartmentModal}
          toggle={this.toggleExistingDepartmentModal}
          /* size="lg" */
        >
          <ModalHeader toggle={this.toggleExistingDepartmentModal}>
            Edit Department
          </ModalHeader>
          <ModalBody>
            <AvForm className="p-2" onValidSubmit={this.handleEditDepartment}>
              <Row>
                <Col md={12}>
                  <AvField
                    name="department"
                    label="Department name"
                    type="text"
                    value={this.state.name}
                    disabled
                  />
                </Col>
                {/* <Col md={4}>
                  <AvField
                    name="manager"
                    label="Supervisor"
                    type="select"
                    value={this.state.manager}
                    className="custom-select"
                  >
                    <option value="Select">Select</option>
                    {this._renderUsersOptions()}
                  </AvField>
                </Col> */}
              </Row>

              <div>{this.__renderDepartmentMembers()}</div>

              {/* <Row className="mb-2">
                <Col md={12}>
                  <Label>Select assets</Label>
                  <Select
                    isMulti={true}
                    options={this.state.assetsOptions}
                    value={this.state.selectedAssets}
                    className="react-select"
                    classNamePrefix="react-select"
                    onChange={(evt) => this.__handleAssetSelectionChange(evt)}
                  ></Select>
                </Col>
              </Row> */}

              <AvField
                name="description"
                label="Description"
                value={this.state.description}
                type="textarea"
                required
              />

              <FormGroup>
                <Label>Thumbnail</Label>
                <p className="text-muted font-14">
                  Recommended thumbnail size 800x400 (px).
                </p>
                <FileUploader
                  onFileUpload={(files) => {
                    this.updateThumbnail('departmentThumbnail', files);
                  }}
                />
              </FormGroup>

              <div className="text-right">
                <Button
                  color="light"
                  type="button"
                  className="mr-1"
                  onClick={this.toggleExistingDepartmentModal}
                >
                  Cancel
                </Button>
                <Button color="primary" type="submit">
                  Update
                </Button>
              </div>
            </AvForm>
          </ModalBody>
        </Modal>

        {/** Invite Users */}
        <Modal
          isOpen={this.state.inviteModal}
          toggle={this.toggleInviteMembersModal}
          /* size="lg" */
        >
          <ModalHeader toggle={this.toggleInviteMembersModal}>
            Invite Members to {this.state.selectedDepartment?.name}
          </ModalHeader>
          <ModalBody>
            <AvForm className="p-2" onValidSubmit={this.handleInviteMembers}>
              <AvField
                name="emails"
                label="Enter Emails"
                type="textarea"
                required
              />
              <small
                className="form-text text-info"
                style={{ marginTop: '-10px' }}
              >
                Separate emails with a comma.
              </small>

              <div className="text-right">
                <Button
                  color="light"
                  type="button"
                  className="mr-1"
                  onClick={this.toggleInviteMembersModal}
                >
                  Cancel
                </Button>
                <Button
                  color="primary"
                  type="submit"
                  disabled={this.state.isInvitingMember}
                >
                  {this.state.isInvitingMember && (
                    <span>
                      <Spinner
                        className="spinner-border-sm"
                        tag="span"
                        color="white"
                      />
                      &nbsp; Inviting...
                    </span>
                  )}
                  {!this.state.isInvitingMember && (
                    <span>
                      <i className="uil uil-user-plus"></i> Invite
                    </span>
                  )}
                </Button>
              </div>
            </AvForm>
          </ModalBody>
        </Modal>
      </Fragment>
    );
  }
}
export default DepartmentManagement;
